/** Frontend routes for entity overview screens (see App.js). */
const enc = (id) => encodeURIComponent(String(id ?? ""));

export const overviewPath = {
  client: (id) => `/data_management/client/${enc(id)}`,
  project: (id) => `/data_management/project/${enc(id)}`,
  consultant: (id) => `/administration/consultant/${enc(id)}`,
  project_task: (id) => `/data_management/project_task/${enc(id)}`,
  document: (id) => `/data_management/document/${enc(id)}`,
  property: (id) => `/data_management/property/${enc(id)}`,
  bank: (id) => `/administration/bank/${enc(id)}`,
  bank_client_account: (id) => `/data_management/bank_client_account/${enc(id)}`,
  bank_project_account: (id) => `/data_management/bank_project_account/${enc(id)}`,
  associated_client: (id) => `/data_management/associated_client/${enc(id)}`,
  client_contact: (id) => `/data_management/client_contact/${enc(id)}`,
  professional: (id) => `/data_management/professional/${enc(id)}`,
  cash: (id) => `/data_management/cash/${enc(id)}`,
  taxation_project: (id) => `/data_management/taxation_project/${enc(id)}`,
  task_comment: (id) => `/data_management/task_comment/${enc(id)}`,
  country: (id) => `/regions/country/${enc(id)}`,
  province: (id) => `/regions/province/${enc(id)}`,
  city: (id) => `/regions/city/${enc(id)}`,
  insurance_carrier: (id) => `/administration/insurance_carrier/${enc(id)}`,
  profession: (id) => `/administration/profession/${enc(id)}`,
  project_category: (id) => `/administration/project_category/${enc(id)}`,
  task_category: (id) => `/administration/task_category/${enc(id)}`,
  document_category: (id) => `/administration/document_category/${enc(id)}`,
};

/** Django ContentType.model (lowercase) → overviewPath key */
export const AUDIT_MODEL_TO_ENTITY = {
  client: "client",
  project: "project",
  projecttask: "project_task",
  consultant: "consultant",
  document: "document",
  property: "property",
  bank: "bank",
  bankclientaccount: "bank_client_account",
  bankprojectaccount: "bank_project_account",
  associatedclient: "associated_client",
  clientcontact: "client_contact",
  professional: "professional",
  cash: "cash",
  taxationproject: "taxation_project",
  taskcomment: "task_comment",
  country: "country",
  province: "province",
  city: "city",
  insurancecarrier: "insurance_carrier",
  profession: "profession",
  projectcategory: "project_category",
  taskcategory: "task_category",
  documentcategory: "document_category",
};

/**
 * @param {keyof typeof overviewPath} entity
 * @param {string|number|null|undefined} id
 * @returns {string|null}
 */
export function getOverviewHref(entity, id) {
  if (id == null || id === "") return null;
  const fn = overviewPath[entity];
  return fn ? fn(id) : null;
}

/**
 * @param {{ model?: string, object_id?: string|number|null }|null|undefined} target
 * @returns {string|null}
 */
export function getAuditTargetOverviewHref(target) {
  if (!target?.object_id) return null;
  const entity = AUDIT_MODEL_TO_ENTITY[String(target.model || "").toLowerCase()];
  return entity ? getOverviewHref(entity, target.object_id) : null;
}

/**
 * @param {{ model?: string, object_id?: string|number|null }|null|undefined} target
 * @returns {string}
 */
export function formatAuditTargetLabel(target) {
  if (!target?.model && !target?.object_id) return "-";
  const model = target.model || "";
  const id = target.object_id ? `(${target.object_id})` : "";
  return `${model} ${id}`.trim() || "-";
}
